


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, Getter, namespace } from 'vuex-class';
import { EventBus } from "@/pitprojekt/event-bus";
import GoogleMapDialog from "@/components/dialog/GoogleMapDialog.vue";
import DetailedStatsTable from "@/components/table/DetailedStatsTable.vue";
import { Product } from "@/pitprojekt/models/Product";
import { Utils } from '@/pitprojekt/utils';
import { StatsTableHeaders } from '@/views/elements/stats-table-headers'
const StatsUruchomieniaModule = namespace('StatsUruchomieniaModule')
const StatsPobraniaModule = namespace('StatsPobraniaModule')
const StatsDeklaracjeModule = namespace('StatsDeklaracjeModule')
const SettingsModule = namespace('SettingsModule')


@Component({
    components: { GoogleMapDialog, DetailedStatsTable }
})
export default class StatsDetails extends Vue {
    @SettingsModule.Getter('selectedProduct') selectedProduct!:number;
    @SettingsModule.Getter('selectedProductObject') selectedProductObject!:Product;
    @SettingsModule.Getter('lastYear') lastYear!:boolean;
    @SettingsModule.Getter('currentUserProducts') currentUserProducts!:Array<Product>;
    @SettingsModule.Action('changeSelectedProduct') changeSelectedProduct: any;

    @StatsUruchomieniaModule.Getter('detailedStatsUruchomienia') detailedStatsUruchomienia! :Array<object>;
    @StatsUruchomieniaModule.Getter('detailedStatsUruchomieniaLoading') detailedStatsUruchomieniaLoading! :boolean;
    @StatsUruchomieniaModule.Action('getDetailedStatsUruchomieniaBetweenDatesForProduct') getDetailedStatsUruchomieniaBetweenDatesForProduct: any;

    @StatsPobraniaModule.Getter('detailedStatsPobrania') detailedStatsPobrania! :Array<object>;
    @StatsPobraniaModule.Getter('detailedStatsPobraniaLoading') detailedStatsPobraniaLoading! :boolean;
    @StatsPobraniaModule.Action('getDetailedStatsPobraniaBetweenDatesForProduct') getDetailedStatsPobraniaBetweenDatesForProduct: any;

    @StatsDeklaracjeModule.Getter('detailedStatsDeklaracje') detailedStatsDeklaracje! :Array<object>;
    @StatsDeklaracjeModule.Getter('detailedStatsDeklaracjeLoading') detailedStatsDeklaracjeLoading! :boolean;
    @StatsDeklaracjeModule.Action('getDetailedStatsDeklaracjeBetweenDatesForProduct') getDetailedStatsDeklaracjeBetweenDatesForProduct: any;


    get simpleRouteName(): string {
        return Utils.getSimpleRouteName(this.$route.name);
    }

    templateHeaderText(): string {
        switch (this.simpleRouteName) {
            case 'uruchomienia': return 'Statystyki uruchomień produktu - przeglądanie';
            case 'pobrania': return 'Statystyki pobrań produktu - przeglądanie';
            case 'deklaracje': return 'Statystyki deklaracji produktu - przeglądanie';
            default: return '?';
        }
    }

    get headersObject(): object {
        switch (this.simpleRouteName) {
            case 'uruchomienia': return StatsTableHeaders.detailedStatsUruchomieniaHeader();
            case 'pobrania': return StatsTableHeaders.detailedStatsPobraniaHeader();
            case 'deklaracje': return StatsTableHeaders.detailedStatsDeklaracjeHeader();
            default: return {};
        }
    }

     get loading(): boolean {
        switch (this.simpleRouteName) {
            case 'uruchomienia': return this.detailedStatsUruchomieniaLoading;
            case 'pobrania': return this.detailedStatsPobraniaLoading;
             case 'deklaracje': return this.detailedStatsDeklaracjeLoading;
            default: return false;
        }
    }

    get dataSource(): Array<object> {
        switch (this.simpleRouteName) {
            case 'uruchomienia': return this.detailedStatsUruchomienia;
            case 'pobrania': return this.detailedStatsPobrania;
            case 'deklaracje': return this.detailedStatsDeklaracje;
            default: return [{}];
        }
    }

    created() {
        this.getDetailedStatsDataAndChangeRoute();
        EventBus.$on('PageTitleDateChangedEvent', this.pageTitleDateChanged);
    }

    beforeDestroy() {
        EventBus.$off('PageTitleDateChangedEvent', this.pageTitleDateChanged);
    }

    getDetailedStatsDataAndChangeRoute() {
        if (!this.selectedProduct) {
            this.changeSelectedProduct(this.currentUserProducts[0].id);
        }

        this.getDetailedStatsData();


        if (this.$route.params.id != this.selectedProduct.toString()) {
            switch (this.simpleRouteName) {
                case 'uruchomienia':
                    this.$router.push({ name: 'stats-uruchomienia-details-index', params: { id: ''+this.selectedProduct } });
                    break;

                case 'pobrania':
                    this.$router.push({ name: 'stats-pobrania-details-index', params: { id: ''+this.selectedProduct } });
                    break;

                case 'deklaracje':
                    this.$router.push({ name: 'stats-deklaracje-details-index', params: { id: ''+this.selectedProduct } });
                    break;
            }
        }
    }

    getDetailedStatsData() {
        switch (this.simpleRouteName) {
            case 'uruchomienia':
                this.getDetailedStatsUruchomieniaBetweenDatesForProduct({'productId': this.selectedProduct, 'lastYear': this.lastYear});
                break;

            case 'pobrania':
                this.getDetailedStatsPobraniaBetweenDatesForProduct({'productId': this.selectedProduct, 'lastYear': this.lastYear});
                break;

            case 'deklaracje':
                this.getDetailedStatsDeklaracjeBetweenDatesForProduct({'productId': this.selectedProduct, 'lastYear': this.lastYear});
                break;
        }
    }

    pageTitleDateChanged() {
        this.getDetailedStatsData();
    }

    getProductIconName(rodzaj: string): string {
        return Utils.getProductIconName(rodzaj);
    }

    @Watch('selectedProduct')
    onSelectedProductChanged() {
        this.getDetailedStatsDataAndChangeRoute();
    }

    showGoogleMapDialogByIP(ip: string) {
        EventBus.$emit('showGoogleMapDialogByIPEvent', ip);
    }

    @Watch('$route', { immediate: true, deep: true })
    updateRoute() {
        this.getDetailedStatsDataAndChangeRoute();
    }


}
